import { Component } from "@angular/core";

@Component({
    selector: "app-supplier-detail-header",
    templateUrl: "./supplier-detail-header.component.html",
    styleUrls: ["./supplier-detail-header.component.scss"],
    standalone: false
})
export class SupplierDetailHeaderComponent {}
